import { render, staticRenderFns } from "./BookingFormSubmissions.vue?vue&type=template&id=6f88f40d&"
import script from "./BookingFormSubmissions.vue?vue&type=script&lang=js&"
export * from "./BookingFormSubmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports